import { useState } from 'react';

const useCustomHook = () => {
  const [creditLoading, setCreditLoading] = useState(false);
  const [accounts, setAccounts] = useState([]);
  const [showSayyah, setShowSayyah] = useState(false);
  const [walletBalance, setWalletBalance] = useState(0);
  const [balance, setBalance] = useState(null); // for guilds
  const [withdrawableBalance, setWithdrawableBalance] = useState(null); // for guilds

  return {
    creditLoading,
    setCreditLoading,
    accounts,
    setAccounts,
    walletBalance,
    setWalletBalance,
    balance,
    setBalance,
    withdrawableBalance,
    setWithdrawableBalance,
    showSayyah,
    setShowSayyah,
  };
};

export default useCustomHook;
